<template>
  <div>
    <h3 class="is-size-5 has-text-weight-medium">
      {{ $t('resourceNotificationsCreateModal.recipientsChooser.title') }}
    </h3>
    <button
      v-if="isLoading"
      class="button is-fullwidth is-large is-white is-loading"
    ></button>
    <p
      v-else-if="isError"
      class="mt-2 has-text-danger is-italic"
    >
      {{ $t('resourceNotificationsCreateModal.recipientsChooser.loading_error') }}
    </p>
    <div v-else class="mt-2">
      <div class="is-flex is-align-items-center">
        <button
          class="button is-small is-link is-light is-rounded"
          :disabled="allRecipientsSelected"
          @click="onSelectAllClick"
        >
          <span class="icon is-small">
            <fa-icon :icon="['fas', 'check']" />
          </span>
          <span>
            {{ $t('resourceNotificationsCreateModal.recipientsChooser.select_all_button') }}
          </span>
        </button>

        <button
          class="ml-2 button is-small is-danger is-light is-rounded"
          :disabled="recipientIds.length === 0"
          @click="onDeselectAllClick"
        >
          <span class="icon is-small">
            <fa-icon :icon="['fas', 'times']" />
          </span>
          <span>
            {{ $t('resourceNotificationsCreateModal.recipientsChooser.deselect_all_button') }}
          </span>
        </button>
      </div>

      <ul class="mt-1 recipients-list">
        <li
          v-for="recipient in recipients"
          :key="recipient.id"
          class="recipient has-border-bottom px-2 py-3"
        >
          <label class="is-flex is-clickable">
            <input
              v-model="recipientIds"
              :value="recipient.id"
              class="checkbox"
              type="checkbox"
            />

            <recipient-list-item
              class="ml-3 is-flex-grow-1"
              :recipient="recipient"
            />
          </label>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import RecipientListItem from './RecipientListItem.vue'

export default {
  name: 'ResourceNotificationsCreateRecipientsChooser',
  components: { RecipientListItem },
  props: {
    value: {
      type: null,
      required: true
    }
  },
  emits: ['input'],
  data: () => ({
    isLoading: false,
    isError: false,
    recipients: []
  }),
  computed: {
    recipientIds: {
      get() { return this.value },
      set(newValue) { this.$emit('input', newValue) }
    },
    allRecipientsSelected() { return this.recipientIds.length === this.recipients.length }
  },
  mounted() {
    this.loadRecipients()
  },
  methods: {
    loadRecipients() {
      this.isLoading = true
      this.isError = false
      this.$repositories()
          .resourceNotifications
          .recipients()
          .then(recipients => { this.recipients = [...recipients] })
          .catch(() => { this.isError = true })
          .finally(() => { this.isLoading = false })
    },
    onSelectAllClick() {
      this.recipientIds = this.recipients.map(recipient => recipient.id)
    },
    onDeselectAllClick() {
      this.recipientIds = []
    }
  }
}
</script>
<style>
.recipients-list {
  height: 50vh;
  overflow: scroll;
}

.recipient {
  transition: color .3s ease;
}

.recipient:last-of-type {
  border-bottom: none;
}

.recipient:hover {
  background-color: #eee;
}
</style>
